import { BackgroundContainer } from "@/lib/background/container"
import { BackgroundContext } from "@/lib/background/context"
import type { Subscription } from "@/lib/subscription"

export namespace Background {
  export type ContextData = {
    subscribeToBackgroundClicks: Functions.Subscribe
  }

  export const Container = BackgroundContainer

  export const Context = BackgroundContext

  export namespace Functions {
    export type Handler = React.MouseEventHandler<HTMLDivElement>

    export type Subscribe = (args: {
      listenerId: Subscription.ListenerId
      onBackgroundClick: Handler
    }) => Subscription.Functions.Unsubscribe
  }
}
